import React from 'react';
import { Text, Stack, Image, ImageFit, PrimaryButton, Spinner, Checkbox } from '@fluentui/react';
import { onAuthenticationEnterPrise } from '../../Containers/LoginEnter';
import { onCloseRightPanel } from "../../Containers/RightPanelAction";
import LinkAPI, { onRequestEnterPrise } from '../../Containers/MainController';
import { ModalView } from "../ModalView";
import BgTrongDongNew from '../../Assets/BgTrongDongNew.png'
import COLOR from "../../Styles/Colors";
import URL from "../../Containers/MainController";

class LoginEnterPrise extends React.PureComponent {

    state = {
        contentDialog: '',
        rememberLogin: true,
        usernameEnter: '',
        passwordEnter: '',
        lastPasswordEnter: '',
        confirmPasswordEnter: '',
        isLogin: this.props.route === 'login',
        isChangePasswordSuccess: false,
        isLoading: false,
        errorMessage: '',
        closeAndBack: false,
        mailXacThuc: '',
        isOpen: false,
        isEye: false
    };

    onCallLoginAPI = () => {
        let { usernameEnter, passwordEnter } = this.state;
        usernameEnter = usernameEnter.trim();
        let payload = new URLSearchParams();
        payload.append('username', usernameEnter);
        payload.append('password', passwordEnter);
        payload.append('grant_type', 'password');
        payload.append('client_id', 'vilis-mobile-client');
        payload.append('client_secret', `n\)3b\^Q7g]Jd6T\&\$\^`);


        let onSuccess = ({ statusCode, response }) => {
            if (statusCode === 200) {
            } else {
                this.setState({ errorMessage: response, isOpen: true, isLoading: false })
            }
        };
        onAuthenticationEnterPrise(payload, { username: usernameEnter, password: passwordEnter }, onSuccess);
    };

    onForgetPassWord = () => {
        this.setState({ isLoading: true });
        let { mailXacThuc } = this.state;
        mailXacThuc = mailXacThuc.trim();
        let payload = new URLSearchParams();
        payload.append('email', mailXacThuc);

        this.setState({ isLoading: true });
        let onSuccess = ({ statusCode, response }) => {
            this.setState({ isLoading: false })
            if (statusCode === 200) {
                this.setState({ isOpen: true, mailXacThuc: '' })
            } else {
                this.setState({ errorMessage: 'Đã có lỗi xảy ra vui lòng thử lại sau.', isOpen: true })
            }
        };
        onRequestEnterPrise(LinkAPI.ForgetPassWordEnter, onSuccess, payload, '');
    };

    onOpenDialog = (route) => () => {
        let content;
        switch (route) {
            case "noAccount": {
                content = 'Thật xin lỗi vì sự bất tiện này, hiện tại do tính bảo mật của dữ liệu, hệ thống chỉ có thể cung cấp tài khoản cho cá nhân, tổ chức liên quan.';
                break;
            }
            case 'forgotPassword': {
                content = 'Để lấy lại mật khẩu, xin vui lòng liên hệ với quản trị viên.';
                break;
            }
            default:
                break
        }
        this.setState({ contentDialog: content });
    };

    onCloseDialog = () => {
        if (this.state.closeAndBack)
            onCloseRightPanel();
        else
            this.setState({ contentDialog: '' })
    };

    onChangeUsername = (usernameEnter) => { this.setState({ usernameEnter }) };
    onChangePassword = (passwordEnter) => this.setState({ passwordEnter });
    onChangeEmail = (_, mailXacThuc) => this.setState({ mailXacThuc });
    onChangeLastPassword = (_, passwordEnter) => this.setState({ lastPasswordEnter: passwordEnter });
    onChangeConfirmPassword = (_, passwordEnter) => this.setState({ confirmPasswordEnter: passwordEnter });

    onLoginPress = () => {
        let { usernameEnter, passwordEnter, isLogin, confirmPasswordEnter, lastPasswordEnter } = this.state;
        usernameEnter = usernameEnter ? usernameEnter.trim() : '';
        this.setState({ isLoading: true });
        if (usernameEnter && passwordEnter) {
            this.onCallLoginAPI();
        } else {
            this.setState({ errorMessage: 'Vui lòng nhập đầy đủ thông tin', isOpen: true, isLoading: false })
        }
    };

    handleEnterPress = (ent) => {
        if (ent.key === 'Enter')
            this.onLoginPress()
    };


    render() {
        let { isLoading } = this.state;
        return (
            <Stack
                className='position-absolute'
                style={styles.containerLogin}>
                <ModalView
                    isOpen={this.state.isOpen}
                    onDismiss={() => { this.setState({ isOpen: false }) }}
                    title={'Thông báo'}
                    mess={this.state.errorMessage}
                />

                <Stack style={styles.modal}>

                    <Stack style={{ justifyContent: 'center', alignItems: 'center', padding: 20, paddingTop: 25 }}>
                        <Image
                            src={require("../../Assets/icon.png")}
                            imageFit={ImageFit.contain}
                            width={50}
                            height={50}
                        />
                        <Text style={{ fontSize: 25, fontFamily: 'Lora', marginTop: 10, color: COLOR.blue, textAlign: 'center' }} >CỔNG THÔNG TIN VNPT ILIS</Text>
                    </Stack>
                    <Stack style={{ paddingLeft: 50, paddingRight: 50, }}>
                        <Stack style={styles.cardInput} >
                            <Stack style={{ flex: 1, }}>
                                <input
                                    disabled={isLoading}
                                    placeholder="Tài khoản đăng nhập"
                                    onChange={(event) => { this.onChangeUsername(event.target.value) }}
                                    value={this.state.usernameEnter}
                                    type="text"
                                    style={styles.inputTDN} />
                            </Stack>
                        </Stack>

                        <Stack style={{ height: 20 }} />
                        <Stack style={styles.cardInput} >
                            <Stack style={{ flex: 1, }}>
                                <input
                                    placeholder="Mật khẩu"
                                    type={this.state.isEye ? "text" : "password"}
                                    name={"matkhau"}
                                    onChange={(event) => { this.onChangePassword(event.target.value) }}
                                    onKeyDown={this.handleEnterPress}
                                    disabled={isLoading}
                                    style={styles.inputTDN} />
                            </Stack>
                            <Stack onClick={() => { this.setState({ isEye: !this.state.isEye }) }} >
                                <Image
                                    src={this.state.isEye ? require("../../Assets/notEye.png") : require("../../Assets/eye.png")}
                                    imageFit={ImageFit.contain}
                                    width={20}
                                    height={20}
                                />
                            </Stack>
                        </Stack>

                        <Stack style={{ marginTop: 15, justifyContent: 'flex-end', flexDirection: 'row' }}>
                            <Checkbox label="Lưu đăng nhập" checked={this.state.rememberLogin} disabled={isLoading} />

                        </Stack>
                        <PrimaryButton style={{ marginTop: 15 }} text="Đăng nhập" onClick={this.onLoginPress} disabled={isLoading} />
                        <Spinner hidden={!isLoading} />
                        <Stack style={{ height: 15 }} />

                        <Text style={{ textAlign: 'center', color: 'gray', fontSize: 10 }}>Tải ứng dụng VNPT-ILIS để có trải nghiệm tốt hơn trên thiết bị di động.</Text>
                        <Stack style={{ flexDirection: 'row', marginTop: 5, justifyContent: 'center' }}>
                            <a href={URL.urlDownloadIOS}>
                                <Image
                                    src={require("../../Assets/DownIOS.png")}
                                    imageFit={ImageFit.contain}
                                    width={80}
                                    height={35}
                                />
                            </a>
                            <Stack style={{ width: 30 }} />
                            <a href={URL.urlDownloadAndroid}>
                                <Image
                                    src={require("../../Assets/DownAndroid.png")}
                                    imageFit={ImageFit.contain}
                                    width={80}
                                    height={35}
                                />
                            </a>
                        </Stack>
                        <Stack style={{ height: 15 }} />
                        {/* {errorMessage ?
                                <MessageBar
                                    messageBarType={MessageBarType.error}
                                    isMultiline={true}
                                >
                                    {errorMessage}
                                </MessageBar> : null
                            }
                            <br />
                            <Link
                                onClick={() => {
                                    this.setState({ isLogin: false })
                                }}
                                style={{ fontSize: 13 }}
                                disabled={isLoading}
                            >
                                Quên mật khẩu ?
                            </Link>
                             <Link
                                onClick={this.onOpenDialog('noAccount')}
                                style={{ fontSize: 13 }}
                                disabled={isLoading}
                            >
                                Bạn chưa có tài khoản ?
                            </Link> */}
                    </Stack>
                </Stack>
            </Stack>
        )
    }
}

export default LoginEnterPrise;

const styles = {
    containerLogin: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundPosition: 'center',
        backgroundColor: '#F8ECE0',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${BgTrongDongNew})`,

    },
    modal: {
        width: '80%',
        maxWidth: 450,
        backgroundColor: 'white',
        borderRadius: 15,
        zIndex: 1
    },
    titleIcon: {
        root: {
            color: COLOR.blue,
        }
    },
    matKhau: {
        boderWidth: 5,
    },
    cardInput: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #585858',
        padding: 4,
        borderRadius: 2
    },
    inputTDN: {
        borderWidth: 0,
        fontSize: 14,
        color: 'black'
    }
};
